<div #map id="map" class="map {{ type }} {{ profSelected }}"></div>